import { RecordContextProvider, ResourceContextProvider, Title, useTranslate } from 'react-admin';

import {
  B2bCompanyDocumentCategory,
  B2bCompanyDocumentCategoryValues,
} from '@Common/types/bo/b2b/companies';

import {
  useDefineAppLocation,
  VerticalTab,
  VerticalTabsLayout,
} from '@sh4res/bo-common/components';
import { B2bCompanyDocumentsByCategoryList } from '@sh4res/bo-common/components/B2bCompanyDocuments/B2bCompanyDocumentsByCategoryList';
import { PageTitle } from '@sh4res/bo-common/components/PageTitle';

interface DocumentsPageProps {
  companyId?: number;
}

const categoryLabels: Record<B2bCompanyDocumentCategory, string> = {
  company: 'resources.bo_common.b2b.documents.categories.company',
  contracts: 'resources.bo_common.b2b.documents.categories.contracts',
  operations: 'resources.bo_common.b2b.documents.categories.operations',
  certificates: 'resources.bo_common.b2b.documents.categories.certificates',
  commercial_supports: 'resources.bo_common.b2b.documents.categories.commercial_supports',
  invoices: 'resources.bo_common.b2b.documents.categories.invoices',
};

export const DocumentsPage = ({ companyId }: DocumentsPageProps) => {
  useDefineAppLocation('companies/documents');
  const translate = useTranslate();

  const translatedTitle = translate('menu.documents');

  return (
    <ResourceContextProvider value="companies/documents">
      <>
        <Title title={translatedTitle} />
        <RecordContextProvider value={{ id: companyId ?? 0 }}>
          <VerticalTabsLayout>
            {B2bCompanyDocumentCategoryValues.map((category) => (
              <VerticalTab
                key={category}
                label={categoryLabels[category]}
                path={category}
                data-testid="BoExternalDocumentsPage_DocumentCategoryVerticalTab"
                sx={{ textTransform: 'none' }}>
                <B2bCompanyDocumentsByCategoryList category={category} companyId={companyId} />
              </VerticalTab>
            ))}
          </VerticalTabsLayout>
        </RecordContextProvider>
        <PageTitle title={translatedTitle} />
      </>
    </ResourceContextProvider>
  );
};
